import React, { Component, Fragment } from 'react'
import {
  Dialog,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import Select from 'react-select'
import _ from 'lodash'

import Body from 'components/typography/body2/index'
import styles from './styles.scss'


class ImportDialog extends Component {
  constructor(props){
    super(props)
    this.state = {
      selected: {}
    }
  }

  componentDidMount() {
    this.props.fetchImportSummary()
  }

  handleCancel = () => {
    const { toggleImportDialog } = this.props
    toggleImportDialog()
  }

  handleSubmit = () => {
    const { importSkusList, importSpecification, toggleImportDialog } = this.props
    const { selected } = this.state
    const skuId = importSkusList.find(skuSummary => skuSummary.sku === selected.value).id
    importSpecification(skuId)
    toggleImportDialog()
  }  

  selectRenderer = ({label, hint, source}) => {
    return (
      <Flex
        key={label}
        align='center'
        auto
        styleName='userInputContainer'
      >
        <div styleName='userInputHeader'>
          <Body>{label}</Body>
        </div>
        <div styleName='selectContainer'>
          <Select
            placeholder={hint}
            value={this.state.selected}
            onChange={(newValue) => this.setState({ selected: newValue} )}
            options={source}
          />
        </div>
      </Flex>
    )
  }

  skuSelectionRenderer = () => {
    const skuSources = this.props.importSkusList.map(skuSummary => ({ value: skuSummary.sku, label: skuSummary.sku }))
    const selectFields = [
      {label: 'Select Product SKU', hint: 'Select product to import from...', source: skuSources},
    ]
    return (
      <div>
        {selectFields.map(field => this.selectRenderer(field))}
      </div>
    )
  }

  render() {
    const { importDialogActive } = this.props
    const { selected } = this.state
    const actions = [
      { label: 'Cancel', onClick: this.handleCancel },
      { label: 'Import', onClick: this.handleSubmit, disabled: _.isEmpty(selected) },
    ]

    return (
      <Dialog
        theme={styles}
        active={importDialogActive}
        onOverlayClick={this.handleCancel}
        onEscKeyDown={this.handleCancel}
        actions={actions}
        title={'Import Product Specification'}
        styleName={'importDialog'}
      >
        {this.skuSelectionRenderer()}
    </Dialog>
    )
  }
}

export default CSSModules(ImportDialog, styles)
